import { onUnmounted } from 'vue';

const scriptId = 'wonderchat-script';
const hiddenClass = 'wonderchat-hidden';

// Course and chapter views currently showing the chatbot. Moving from one to
// the other unmounts the old view before mounting the new one, so the count
// briefly drops to zero; the hide check waits a microtask to see past that.
let openCourseViews = 0;

/**
 * The WonderChat loader runs once per page load (window.__wonderchatLoaded)
 * and renders only after a network round trip, so it is added once and never
 * removed. Outside the course section it is hidden with a body class instead,
 * which also covers a widget that finishes rendering after the member left.
 */
function addLoaderScript() {
    if (document.getElementById(scriptId)) {
        return;
    }

    const script = document.createElement('script');
    script.src = 'https://app.wonderchat.io/scripts/wonderchat.js';
    script.id = scriptId;
    script.setAttribute('data-name', 'wonderchat');
    script.setAttribute('data-address', 'app.wonderchat.io');
    script.setAttribute('data-id', 'cm37rcup2012n204tgw2bx0al');
    script.setAttribute('data-widget-size', 'normal');
    script.setAttribute('data-widget-button-size', 'normal');
    script.defer = true;
    // A failed download leaves the element behind without running the loader,
    // which would block every later course visit until a reload.
    script.addEventListener('error', () => script.remove());
    document.body.appendChild(script);
}

function hideWhenNoCourseViewIsOpen() {
    if (openCourseViews > 0) {
        return;
    }

    // Close the chat first so the scroll lock it puts on the page on mobile is undone.
    window.toggleChat?.(false);
    document.body.classList.add(hiddenClass);
}

export function useCourseChatbot() {
    let isShowing = false;

    const showChatbot = () => {
        if (isShowing) {
            return;
        }

        isShowing = true;
        openCourseViews++;
        document.body.classList.remove(hiddenClass);
        addLoaderScript();
    };

    onUnmounted(() => {
        if (!isShowing) {
            return;
        }

        isShowing = false;
        openCourseViews--;
        queueMicrotask(hideWhenNoCourseViewIsOpen);
    });

    return {
        showChatbot,
    };
}
